import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

interface ViewModel {
    form: FormGroup;
}

@Component({
    selector: 'app-enable-bypass',
    templateUrl: './enable-bypass.component.html',
    styleUrls: ['./enable-bypass.component.scss']
})
export class EnableBypassComponent implements OnInit {
    constructor(
        private ref: MatDialogRef<EnableBypassComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}

    ngOnInit() {
    }
}